<template>
  <div id="opple-date-picker-group" class="opple-date-picker-group">
    <div v-if="showQuickActions" class="select-all">
      <p @click="selectAllDays">
        {{ $t('findDevice.selectAll') }}
      </p>
      <p @click="setSelectedNoDay">
        {{ $t('hcl.clear') }}
      </p>
    </div>
    
    <div class="opple-date-picker-group-container">
      <DateItem
        ref="DateItem"
        :first-day="startDate"
        :hiden-month="true"
        :month="1"
        :holiday-list="emptyList"
        :holiday-date-list="emptyList"
        :default-select="emptyList"
        :country-value="countryValue"
        @changeSelect="val => changeSelect(1, val)"
      />
    </div>
  </div>
</template>
<script>
import DateItem from './item.vue'

export default {
  components: {
    DateItem,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    showQuickActions: {
      type: Boolean,
      default: true,
    },
    // 一行几列 默认4
    column: {
      type: Number,
      default: 4,
    },
    // 起始日期 - 结束日期 会过滤这个日期前的
    range: {
      type: Array,
      default: () => [],
    },
    // 当前年
    year: {
      type: [String, Number],
      default: () => new Date().getFullYear(),
    },
    // // 节假日
    // holidayList: {
    //   type: Array,
    //   default: () => [],
    // },
    // 过滤选中的日期 一般用来排除调休的双休日
    filterList: {
      type: Array,
      default: () => [],
    },
    countryValue: {
      type: String,
      default: 'CN',
    },
  },

  data() {
    return {
      emptyList: [],
      startDate: new Date(2099, 0, 1),
      dateList: [],
      selectList: {},
    }
  },

  computed: {},

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.syncValueToDateItem(val)
      },
    },
  },

  mounted() {
    this.init()
    this.syncValueToDateItem(this.value)
  },

  created() {},
  beforeDestroy() {
  },

  methods: {
    init() {
    },
    syncValueToDateItem(val) {
      const next = Array.isArray(val) ? val.slice() : []
      this.selectList = next.length ? { 1: next } : {}
      this.$nextTick(() => {
        if (this.$refs.DateItem) {
          this.$refs.DateItem.setSelectedDay(next)
        }
      })
    },
    setSelectedNoDay() {
      this.selectList = {}
      this.$refs.DateItem.setSelectedDay([])
      this.$emit('input', [])
    },

    selectAllDays() {
      const list = new Array(31).fill(1).map((item, i) => `2099-01-${('0' + (i + 1)).slice(-2)}`)

      this.selectList = { 1: list.slice() }
      this.$refs.DateItem.setSelectedDay(list)

      this.$emit('input', list)
    },
  
    changeSelect(month, val) {
      this.selectList[month] = val.slice()

      const flatList = this.getFlatList()

      this.$emit('input', flatList)
      this.$emit('changeSelect', flatList, this.selectList)
    },

    getFlatList() {
      return Object.values(this.selectList).reduce((pre, next) => pre.concat(next.slice()), [])
    },
  },
}
</script>

<style lang="scss" scoped>
.opple-date-picker-group {
  box-sizing: border-box;
  margin-top: 4px;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 40px);
  &-container {
    height: 300px;
    // max-height: 1203px;
    // min-height: 401px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .opple-date-picker {
      height: 401px!important;
    }
  }
  .select-all {
    display: flex;
    justify-content: end;
    color: #469ef5;

    p {
      padding-right: 10px;
      cursor: pointer;
    }
  }
}
/* 隐藏星期标题 */
::v-deep .el-calendar-table thead {
  display: none;
}
</style>
